import { render, staticRenderFns } from "./UpdateChannelOnboardPFACModal.vue?vue&type=template&id=a7e9e7ca&scoped=true"
import script from "./UpdateChannelOnboardPFACModal.vue?vue&type=script&lang=js"
export * from "./UpdateChannelOnboardPFACModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateChannelOnboardPFACModal.vue?vue&type=style&index=0&id=a7e9e7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e9e7ca",
  null
  
)

export default component.exports